/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

type Props = {
    page?: number;
    pageSize?: number;
    name?: string;
    company_name?: any;
};

export const loadAdminUsers = createAsyncThunk(
    'api/admin/users',
    async ({ page, pageSize, name, company_name }: Props) => {
        return await api.admin.getAdminUsers(page, pageSize, name, company_name);
    }
);
